import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M12.2,0C7.6,0,3.9,3.7,3.9,8.2c0,7.4,7.6,16,7.9,16.3l0.4,0.4l0.4-0.4c0.3-0.4,7.9-9,7.9-16.3 C20.4,3.7,16.7,0,12.2,0 M12.3,11.5c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C15.5,10.1,14,11.5,12.3,11.5" />
    </g>
  </svg>
);
